import React from 'react';
import { IconFileUploadThin } from '@saucelabs/sl-component-icons';
import PropTypes from 'prop-types';
import { useDragAndDrop } from '@saucelabs/sl-hook-dropzone';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import UploadAppButton from './UploadAppButton';
import Styles from './AppUploadBox.styles';
import OverlayBox from './OverlayBox';

const AppUploadBox = ({ onSelectFile, onUploadClick }) => {
  const { uploadContainerProps, isDragActive } = useDragAndDrop({
    onDrop: (file) => {
      onSelectFile(file);
      recordTrack('App file selected through drag and drop');
    },
    onUploadClick,
    fileTypes: '.apk,.ipa',
  });

  return (
    <div className={Styles.default}>
      <OverlayBox
        {...{ isDragActive, uploadContainerProps }}
        text="Drop Here"
      >
        <div className={Styles.box}>
          <IconFileUploadThin className={Styles.icon} />
          <p>
            <span>Drag & Drop</span>
            <br />
            <span>or</span>
          </p>
          <UploadAppButton
            onSelectFile={onSelectFile}
            onUploadClick={onUploadClick}
          />
        </div>
      </OverlayBox>
    </div>
  );
};

AppUploadBox.propTypes = {
  onSelectFile: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired,
};

export default AppUploadBox;
